import { http } from "../ConnectApi/ConnectApi";

export async function getCuponController(data: { couponCode: string }) {
  try {
    const response = await http.post('business/redeem', data, {
      withCredentials: true
    });

    return response;
  } catch (error: any) {
    console.error('Error during request:', error.response?.data || error.message);
    throw error;
  }
}
